import { WixConnect } from 'shared/utils/wix-connect';
import { SimpleVideoThumbnail } from './simple';
import styles from './mobile-thumb.styl';


@WixConnect(styles)
export class ActiveFrame extends React.Component {
  static propTypes = {
    children: React.PropTypes.any,
  };

  render() {
    return (
      <div styleName="frame">
        <div styleName="content">
          {this.props.children}
        </div>
        <div styleName="border" />
      </div>
    );
  }
}

@WixConnect(styles)
export class DurationInfo extends React.Component {
  static propTypes = {
    durationStr: React.PropTypes.string,
  };

  render() {
    return (
      <div styleName="duration">
        <span>{this.props.durationStr}</span>
      </div>
    );
  }
}


@WixConnect(styles)
export class ActiveMobileThumbnail extends React.Component {

  static propTypes = {
    video: React.PropTypes.object,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
  };

  render() {
    const { video, video: { durationStr }, width, height } = this.props;

    return (
      <ActiveFrame>
        <SimpleVideoThumbnail video={video}
                              width={width}
                              height={height} />
        <DurationInfo durationStr={durationStr} />
      </ActiveFrame>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/thumbnail/mobile-thumb.js